module.exports = __webpack_public_path__ + "vue_assets/img/badge_deios_platinum.7ad9a8c7.png";